import React from 'react';
import { MenuItem, Toolbar, Typography } from '@mui/material';
import { useUserRolePermissions } from 'hooks';
import { func } from 'prop-types';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

const MobileMenuItems = ({ createNewPto, toggleDrawer }) => {
  const { isProductOwnerManage, isInventoryOwner } = useUserRolePermissions();

  return (
    <Toolbar disableGutters sx={{ height: 56, top: 56 }} variant="toolbar-button-menu">
      {isProductOwnerManage && isInventoryOwner && (
        <MenuItem
          label="Add new"
          onClick={createNewPto}
          sx={{
            bgcolor: 'secondary.main',
            flex: 1,
            height: 56,
            px: 1,
          }}
          variant="button-outlined"
        >
          <AddRoundedIcon sx={{ color: 'surface.white' }} />
          <Typography sx={{ color: 'surface.white', fontSize: 16, mt: '2px' }} variant="button">
            Add New
          </Typography>
        </MenuItem>
      )}
      <MenuItem
        label="Filters"
        onClick={() => toggleDrawer()}
        sx={{
          color: 'primary.main',
          flex: 1,
          height: 56,
          px: 1,
        }}
        variant="button-outlined"
      >
        <Typography sx={{ color: 'primary.main', fontSize: 16, mt: '2px' }} variant="button">
          Filters
        </Typography>
        <ChevronRightRoundedIcon />
      </MenuItem>
    </Toolbar>
  );
};

MobileMenuItems.propTypes = {
  createNewPto: func.isRequired,
  toggleDrawer: func.isRequired,
};

export default MobileMenuItems;
